import React from "react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "@/components/ui/card";

async function fetchJobs() {
  const { data, error } = await supabase
    .from("jobs")
    .select("id,ticket_number,status,priority,job_type,service_address,received_at")
    .order("received_at", { ascending: false })
    .limit(5);
  if (error) throw error;
  return data ?? [];
}

export default function JobsList() {
  const { data: jobs, isLoading, error } = useQuery({
    queryKey: ["jobs-list"],
    queryFn: fetchJobs,
  });

  if (isLoading) return <div className="py-8 text-center">Loading jobs…</div>;
  if (error) return <div className="text-red-500 text-center py-8">Failed to load jobs.</div>;
  if (!jobs.length) return <div className="py-8 text-center">No jobs found.</div>;

  return (
    <div className="grid md:grid-cols-2 gap-6">
      {jobs.map((job: any) => (
        <Card key={job.id}>
          <CardHeader>
            <CardTitle className="flex items-center gap-3">
              <span className="text-teal-600 font-mono text-lg">#{job.ticket_number}</span>
              <span className="rounded bg-slate-100 text-xs px-2 py-1 text-slate-600 ml-auto">{job.status}</span>
            </CardTitle>
            <CardDescription>
              {job.job_type} • Priority: <span className="capitalize">{job.priority}</span>
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="text-sm text-slate-700">
              <span className="font-medium">Address:</span> {job.service_address}
            </div>
            <div className="text-slate-400 text-xs mt-2">
              Received: {job.received_at ? new Date(job.received_at).toLocaleString() : "N/A"}
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
